import styled from "styled-components";
import DownArrow from "web/assets/images/arrow_bottom_down_downward_navigation_icon.png";
const Wrapper = styled.div`
  align-items: stretch;
  display: flex;
  width: 100%;
  flex-direction: column;
  /* gap:20px; */
`;
const ChartSection = styled.div`
  display: flex;
  width: 100%;
  gap: 0 20px;
  > div {
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    min-height: 249px;
    position: relative;
    width: 50%;
  }
  @media (max-width: 1023px) {
    flex-direction: column;
    > div {
      width: 100%;
    }
  }
`;
const Orders = styled.div``;
const Subscriptions = styled.div``;
const Dispute = styled.div``;
const Header = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  justify-content: space-between;
  border-bottom: solid 1px #97979729;

  > h3 {
    font-size: 16px;
    color: #000000;
    text-transform: uppercase;
    font-family: "latobold";
  }
  .action-wrapper{
    display: flex;
    width: 500px;
    button{
      margin: 5px; 
    }
  }
  .subscription-export-btn{
    background: #27911b;
    color: white;
    border: 0;
    border-radius: 5px;
    padding: 5px 15px;
    margin: 5px;
  }
  .header-search-wrapper-reports{
    width: 500px;
    display: flex;
  }
  @media (max-width: 465px){
    height: auto;
    display: block;
    position: relative;
    width: 100%;
    > h3{
      margin: 12px 0;
    }
    .action-wrapper, .header-search-wrapper-reports{
      width: 100%;
      display: block;
      button{
        margin: 10px 0;
      }
    }
  }
`;
const ChartBox = styled.div`
  padding: 15px 10px;
  position: relative;
  .chartjs-render-monitor {
    height: 190px !important;
  }
`;
const SearchWrapper = styled.div`
  display: flex;
  position: relative;
  border-radius: 4.2px;
  overflow: auto;
  max-width: 396px;
  min-width: 200px;
  width: 100%;
  justify-content: end;
  input {
    background: #ffffff;
    border: none;
    padding: 4px 35px 4px 15px;
    width: 100%;
    border-radius: 3px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #00000087;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #00000087;
    }

    ::placeholder {
      color: #00000087;
    }
  }
  svg {
    position: absolute;
    right: 10px;
    top: 9px;
    color: #525e66;
  }
  margin: 4px;
  @media (max-width: 465px){
    margin-left: 0px;
    max-width: 100%;
  }
`;
const TableWrapper = styled.div`
  box-shadow: 0 0 12px 0 rgb(0 0 0 / 8%);
  background-color: #ffffff;
  min-height: 249px;
  position: relative;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  .purchase-report-top-head{
    align-items: center;
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #97979729;
  }
  .purchase-report-info-head{
    display: flex;
    justify-content: space-between;
    .info-section-left{
      display: flex;
      > div {
        display: flex;
        flex-direction: column;
        : last-child{
          margin-left: 40px;
        }
      }
    }
    div[role=button]{
      width: auto;
      float: left;
    }
    p.info-label{
      position: relative;
      min-width: 130px;
    }
    p.info-label:after{
      content: ":";
      right: 5px;
      position: absolute;
    }
    button{
      background: #27911b; 
      color: white; 
      border: 0;
      border-radius: 5px;
      padding: 5px 15px;
      margin: 5px
    }
  }
  
  @media (max-width: 465px){
    .purchase-report-top-head{
      display: block;
      width: 100%;
    }
    .purchase-report-info-head {
      display: block;
      p{
        font-size: 14px;
        line-height: 18px;
      }
      p.info-label{
        min-width:142px;
      }
      p.info-label:after{
        right: 8px;
      }
      button{
        margin: 5px 0;
      }
      .info-section-left{
        display: block;
        width: 100%;
        > div{
          display: block;
          width: 100%;
          :last-child{
            margin-left: 0;
          }
        }
      }
    }
  }
`;

const TableSection = styled.div`
  padding: 0px 12px;
  overflow: auto;
  .table-responsive {
    min-height: 124px;
  }
  .table thead th,
  .table td,
  .table th {
    border: none;
    font-size: 14px;
  }
  .table tbody tr:nth-child(odd) {
    background-color: #fbfbfb;
  }
  tbody {
    position: relative;
  }
  @media (max-width: 767px) {
    max-width: 100%;
    overflow: auto;
  }
`;
const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  select,
  input {
    padding: 5px;
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 10px 13px 10px 13px;
    border-radius: 5px;
    background-color: #e8e2e2;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    min-width: 196px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  select {
    background-image: url(${DownArrow});
    background-repeat: no-repeat;
    background-position: calc(100% - 10px) 50%;
    padding: 10px 25px 10px 13px;
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 16px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    border-color: none;
  }
  .chartModal {
    max-width: 172px;
    min-width: 0px;
  }
  .basic-multi-select {
    margin: 2px 0;
  }
  .select__value-container {
    input {
      padding: 7px 0;
      min-width: auto;
    }
  }
  .select__value-container {
    max-height: 78.38px;
    overflow: auto;
  }
  /* .react-select-2-input {
    padding: 7px 0;
  } */
  .select__control {
    border: none;
    background-color: #e8e2e2;
  }
  .react-select-2-input {
    padding: 5px 0;
  }
`;
const SelectWrapperPostVisibilty = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  /* min-width: 100px; */
  .custom-date-piker{
    margin-top: 2px;
  }
  .css-yk16xz-control:hover{
    border: solid 1px #87cdf1;
  }
  select,
  input {
    padding: 5px;
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 5px 13px 10px 10px;
    border-radius: 5px;
    /* background-color: #e8e2e2; */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* min-width: 196px; */
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  select {
    background-image: url(${DownArrow});
    background-repeat: no-repeat;
    background-position: calc(100% - 10px) 50%;
    padding: 8px 25px 10px 13px;
    border: solid 1px #87cdf1 !important;
  }
  .file-input-wrapper .MuiFormControl-root{
    height: 45px;
  }
  .file-input-wrapper .MuiFormControl-root .MuiInput-root {
      padding: 2px 12px 0px 0px;
  }
  .fQtZNt select, .fQtZNt input{
    border: solid 1px #87cdf1 !important;
    padding: 6px 25px 10px 13px !important;
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 16px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    border-color: none;
  }
  .chartModal {
    max-width: 172px;
    min-width: 0px;
  }
  .basic-multi-select {
    margin: 2px 0;
  }
  .select__value-container {
    input {
      padding: 7px 0;
      min-width: auto;
    }
  }
  .select__value-container {
    max-height: 78.38px;
    overflow: auto;
  }
  /* .react-select-2-input {
    padding: 7px 0;
  } */
  .select__control {
    border: solid 1px #87cdf1;
    /* border: none;
    background-color: #e8e2e2; */
  }
  .react-select-2-input {
    padding: 5px 0;
  }
`;
const DateWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  input {
    padding: 5px;
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 10px 13px 10px 13px;
    border-radius: 5px;
    background-color: #e8e2e2;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    min-width: 165px;
    max-height: 42px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  label {
    padding: 9px;
    margin: 2px 0 0;
    font-size: 16px;
  }
`;

const InnerBox = styled.div`
  margin-bottom: 20px;
  .flex-wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
    > div {
      h5 {
        font-size: 20px;
      }
    }
    .web-view {
      display: block;
    }
  }
  @media (max-width: 400px) {
    .flex-wrapper {
      flex-direction: column;
      align-items: flex-start;
      .web-view {
        display: none;
      }
    }
  }
`;

const TooltipCss = styled.div`
  a.tip {
    text-decoration: none;
  }
  a.tip:hover {
    cursor: help;
    position: relative;
  }
  a.tip span {
    display: none;
  }
  a.tip:hover span {
    border: #c0c0c0 1px dotted;
    border-radius: 5px;
    padding: 10px;
    display: block;
    z-index: 100;
    background: url(../images/status-info.png) #0a1f30 no-repeat 100% 5%;
    right: 0px;
    margin: 10px;
    width: 200px;
    position: absolute;
    top: 10px;
    text-decoration: none;
    color: white;
  }
`;

export {
  Wrapper,
  ChartSection,
  SelectWrapper,
  SelectWrapperPostVisibilty,
  Orders,
  Subscriptions,
  InnerBox,
  Dispute,
  Header,
  ChartBox,
  SearchWrapper,
  DateWrapper,
  TableWrapper,
  TableSection,
  TooltipCss,
};
